import { AnalyticsSummary } from "@apis:analytics/analytics";

export const summarySelector = (data: AnalyticsSummary) => {
  return {
    activeUsersYesterday: data.activeUsersYesterday.reduce(
      (sum, user) => sum + user.numLogins,
      0,
    ),
    activeUsersPeriod: data.activeUsersPeriod.reduce(
      (sum, user) => sum + user.numLogins,
      0,
    ),
    activeUsersPeriodData: data.activeUsersPeriod,
    activeUsersPeriodDistinct: data.activeUsersPeriodDistinct,
    requestsYesterday: data.requestsYesterday.reduce(
      (sum, request) => sum + request.numRequests,
      0,
    ),
    requestsPeriod: data.requestsPeriod.reduce(
      (sum, request) => sum + request.numRequests,
      0,
    ),
    requestsPeriodData: data.requestsPeriod,
  };
};
